export const unAuthRoutes = ['/login', '/forgot-password', '/reset-password'];
